export default function LFP(props: any) {
    return (
        <svg width="21" height="19" viewBox="0 0 21 19" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 3.54604C1 2.67816 1.70355 1.97461 2.57143 1.97461H18.2857C19.1536 1.97461 19.8571 2.67816 19.8571 3.54604V16.6413C19.8571 17.5092 19.1536 18.2127 18.2857 18.2127H2.57143C1.70355 18.2127 1 17.5092 1 16.6413L1 3.54604Z"
                stroke="black"
                strokeWidth="1.3"
            />
            <path
                d="M4.14258 0.796177C4.14258 0.579208 4.31847 0.40332 4.53544 0.40332H5.84496C6.06193 0.40332 6.23782 0.579208 6.23782 0.796177V1.97475H4.14258V0.796177Z"
                fill="black"
            />
            <path
                d="M14.6191 0.796177C14.6191 0.579208 14.795 0.40332 15.012 0.40332H16.3215C16.5385 0.40332 16.7144 0.579208 16.7144 0.796177V1.97475H14.6191V0.796177Z"
                fill="black"
            />
            <path d="M4 7.68945L4 12.6818H7.05603" stroke="black" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M8.95508 12.9941V8.00177H12.0111" stroke="black" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M8.95508 10.4981H12.0111" stroke="black" strokeWidth="0.9" strokeLinecap="round" />
            <path d="M13.9097 8.00195V12.9943" stroke="black" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M13.9102 8.00195H15.6783C16.3293 8.00195 16.857 8.5297 16.857 9.18071V9.18071C16.857 9.83171 16.3293 10.3595 15.6783 10.3595H13.9102V8.00195Z"
                stroke="black"
                strokeWidth="0.9"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
